<template>
  <KikButton
    :class="[showScrollToTop ? 'visible translate-y-0 opacity-100' : 'invisible translate-y-full opacity-0']"
    data-testid="to-top__btn"
    aria-label="Scroll up"
    square
    class="fixed bottom-1 right-1 z-10 !rounded-full transition-all duration-150 desktop:bottom-10 desktop:right-10"
    @click="toTopClick"
  >
    <SfIconArrowUpward size="lg" />
  </KikButton>
</template>

<script lang="ts" setup>
import { SfIconArrowUpward } from '@storefront-ui/vue';
import { useToTop } from './useToTop';

const { showScrollToTop, toTopClick } = useToTop();
</script>
